export const getCurrentRole = (storageKey = "curriculumUserRole"): string[] => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return [];

    const parsed = JSON.parse(raw) as string[];

    if (Array.isArray(parsed)) {
      return parsed.map((role) => role.trim());
    }

    return [];
  } catch (error) {
    console.log("Error parsing role:", error);
    return [];
  }
};
